import { isUncertainWrite } from "../write-failure";

export type ProfileNotice = {
  readonly tone: "muted" | "saved" | "error";
  readonly text: string;
} | null;

export function writeFailureNotice(failure: unknown): {
  readonly uncertain: boolean;
  readonly notice: ProfileNotice;
} {
  const error =
    failure instanceof Error
      ? failure
      : new Error("Could not confirm the change.");
  const uncertain = !(failure instanceof Error) || isUncertainWrite(error);
  return {
    uncertain,
    notice: {
      tone: "error",
      text: uncertain
        ? "Could not confirm the change. Refresh saved values before trying again. Your draft is kept."
        : error.message,
    },
  };
}
